import AnalyticsContainer from "./analyticsContainer";

export default AnalyticsContainer;